/** Shell single-quote a value for embedding in a bash command line. */
export function q(value) {
    return `'${value.replace(/'/g, `'\\''`)}'`;
}
//# sourceMappingURL=quote.js.map